define('paychex.app.messages/drawer/messageDetail/MessageDetailController',[
    'lodash',
    'jquery',
    'paychex.topics.common',
    'paychex.core/Logger',
    'paychex.core/Tracker',
    'paychex.app.common/DeviceProfile'
], function (_,
             $,
             eventTopics,
             Logger,
             Tracker,
             DeviceProfile) {
    'use strict';

    return [
        'MessageListModelService',
        'DrawerManager',
        'GlobalStateService',
        '$scope',
        '$timeout',
        'TranslationService',
        function (MessageListModelService,
                  DrawerManager,
                  GlobalStateService,
                  $scope,
                  $timeout,
                  TranslationService) {

            // A reference to self
            var self = this,
                internal,
                lifecycle,
                log = Logger.get('paychex.app.panel.messageList.MessageDrawerController', {level: 'ALL'});
            // var Constants = {
            //    NAMESPACE: 'paychex.app.drawer.messageDrawer.controllers.MessageDrawerController',
            //    DRAWER_ELEMENT_ID: 'listPanelDrawer'
            // };

            //TODO this can probably be removed
            self.overrideOverflow = false;

            internal = {
                updateInProgress: false,
                constants: {
                    DIMENSION_32: 'Message List: Message',
                    CATEGORY: 'Messages'
                },

                // defect 100018- Drawer should work based off of the 'current message' loaded in the drawer, and not
                //      what is currently opened in the list panel
                //  to fix this, added- drawerActiveGroup and drawerActiveMessage.  These variables will keep track
                //     of the currently loaded message in the drawer.

                // save  panelActiveGroup/activeMessage(passed from listPanel) to
                //   drawerActiveGroup/drawerActiveMessage
                setDrawerActiveItem: function setDrawerActiveItem() {
                    var panelActiveGroup = MessageListModelService.getActiveGroup(),
                        panelActiveMessage = MessageListModelService.getActiveMessage();
                    if (panelActiveGroup && panelActiveMessage) {
                        internal.drawerActiveGroup = panelActiveGroup;
                        internal.drawerActiveMessage = panelActiveMessage;
                    }
                },

                // drawer message can be different than the panel message. We need to use message loaded in
                // the drawer for all drawer actions.
                getDrawerActiveItem: function getDrawerActiveItem() {
                    internal.panelActiveGroup = MessageListModelService.getActiveGroup();
                    internal.drawerItemDifferent = false;
                    if (internal.panelActiveGroup !== internal.drawerActiveGroup) {
                        internal.drawerItemDifferent = true;
                        if (internal.drawerActiveGroup && internal.drawerActiveMessage) {
                            MessageListModelService.setActiveGroup(internal.drawerActiveGroup);
                            MessageListModelService.setActiveMessage(internal.drawerActiveMessage);
                        }
                    }
                },

                // after drawer action is complete- restore  panel item
                //  (for some actions-markRead/unread/download etc.. we don't want to change the panel active item.
                //    without restore- panel item will change to drawer item)
                restoreActiveItem: function restoreActiveItem() {
                    if (internal.drawerItemDifferent) {
                        MessageListModelService.setActiveGroup(internal.panelActiveGroup);
                    }
                },

                updateMessage: function updateMessage(savedState) {
                    if (internal.updateInProgress === false) {
                        internal.updateInProgress = true;
                        $timeout(function onTimeout() {
                            var newMessage,
                                savedMessage = _.get(savedState, 'activeMessage.message');
                            internal.setDrawerActiveItem();

                            if(  savedMessage ){
                                MessageListModelService.setActiveGroup(MessageListModelService.getMessageGroupById(savedMessage.clientId));
                                MessageListModelService.setActiveMessage(savedMessage);
                            }

                            newMessage = MessageListModelService.getActiveMessage();

                            if (newMessage && newMessage.message !== null) {
                                self.model = newMessage;
                            }
                            else{
                                self.closeDrawer();
                            }
                            internal.updateInProgress = false;
                        });
                    }
                }
            };

            lifecycle = {
                id: 'paychex.app.drawer.messageDrawer',
                /**
                 * @ngdoc method
                 * @function init
                 * @memberOf paychex.app.drawer.messageDrawer.controllers.MessageDrawerController
                 * @description
                 * Method run when the messageDrawer is loaded. Initializes variables and then calls
                 * {@link paychex.app.drawer.messageDrawer.controllers.MessageDrawerController#load load()}
                 */
                init: function init() {
                    self.model = {};
                    internal.registrations = MessageListModelService.on('messageList', 'active-changed, collection-changed', internal.updateMessage);
                },

                /**
                 * Loads lifecycle method
                 * @param {Object} state - The global state
                 * @param {Object} context  - The context if one was specified
                 * @param {Object} savedState - the savedState (returned from pause) if the drawer is going restored after the user
                 * pressed the back button to pop a drawer that was pushed onto the stack on top of the message drawer.
                 */
                load: function load(state, context, savedState) {
                    internal.state = 'open';
                    internal.updateMessage(savedState);
                },
                /**
                 * @ngdoc method
                 * @function reload
                 * @memberOf paychex.app.drawer.messageDrawer.controllers.MessageDrawerController
                 * @instance
                 * @description
                 * Clears the model and calls {@link paychex.app.drawer.messageDrawer.controllers.MessageDrawerController#load load()}
                 */
                reload: function reload() {
                    self.model = {};
                },
                /**
                 * @ngdoc method
                 * @function unload
                 * @memberOf paychex.app.drawer.messageDrawer.controllers.MessageDrawerController
                 * @instance
                 * @description
                 * Stub method - unload functionality has not yet been defined.
                 */
                unload: function unload() {
                    if (internal.state !== 'closed') {
                        internal.getDrawerActiveItem();
                        MessageListModelService.setActiveMessage(null);
                        internal.restoreActiveItem();
                        _.forOwn(internal.registrations, function iter(reg) {
                            reg();
                        });
                    }
                    internal.state = 'closed';
                },

                pause: function pause(){
                    return {
                        activeMessage : self.model
                    };
                }
            };

            // For tracking
            self.trackCloseEvent = function trackCloseEvent() {
                Tracker.events.fire('Sub-Navigation', {
                    category: internal.constants.CATEGORY,
                    label: 'Exit',
                    dimension32: internal.constants.DIMENSION_32
                });
            };

            /**
             * @ngdoc method
             * @function moveToPreviousMessage
             * @memberOf paychex.app.drawer.messageDrawer.controllers.MessageDrawerController
             * @instance
             * @description
             * Navigates to the previous message
             */
            self.moveToPreviousMessage = function moveToPreviousMessage() {
                internal.getDrawerActiveItem();
                MessageListModelService.moveToPreviousMessage();
                Tracker.events.fire('Previous Message', {
                    category: internal.constants.CATEGORY,
                    label: _.get(MessageListModelService.getActiveMessage(), 'message.subject', ''),
                    tags: ['button'],
                    dimension32: internal.constants.DIMENSION_32
                });
            };

            /**
             * @ngdoc method
             * @function moveToNextMessage
             * @memberOf paychex.app.drawer.messageDrawer.controllers.MessageDrawerController
             * @instance
             * @description
             * Navigates to the next message
             */
            self.moveToNextMessage = function moveToNextMessage() {
                internal.getDrawerActiveItem();
                MessageListModelService.moveToNextMessage();
                Tracker.events.fire('Next Message', {
                    category: internal.constants.CATEGORY,
                    label: _.get(MessageListModelService.getActiveMessage(), 'message.subject', ''),
                    tags: ['button'],
                    dimension32: internal.constants.DIMENSION_32
                });
            };

            /**
             * @ngdoc method
             * @function deleteMessage
             * @memberOf paychex.app.drawer.messageDrawer.controllers.MessageDrawerController
             * @instance
             * @description
             * Deletes the message
             */
            self.deleteMessage = function deleteMessage() {
                Tracker.events.fire('Delete', {
                    category: internal.constants.CATEGORY,
                    label: _.get(MessageListModelService.getActiveMessage(), 'message.subject', ''),
                    tags: ['button'],
                    dimension32: internal.constants.DIMENSION_32
                });
                internal.getDrawerActiveItem();
                // Call into the service
                MessageListModelService.deleteActiveMessage();
            };

            /**
             * @ngdoc method
             * @function markMessageRead
             * @memberOf paychex.app.drawer.messageDrawer.controllers.MessageDrawerController
             * @instance
             * @description
             * Marks the message as read
             */
            self.markMessageRead = function markMessageRead() {
                Tracker.events.fire('Mark As Read', {
                    category: internal.constants.CATEGORY,
                    label: _.get(MessageListModelService.getActiveMessage(), 'message.subject', ''),
                    tags: ['button'],
                    dimension32: internal.constants.DIMENSION_32
                });
                internal.getDrawerActiveItem();
                MessageListModelService.markActiveMessageRead()
                    .catch(function onError(error) {
                        // Log the error
                        log.warn('Could not mark the selected message as read', error);
                        return undefined;
                    })
                    .done();
                internal.restoreActiveItem();
            };

            /**
             * @ngdoc method
             * @function markMessageUnread
             * @memberOf paychex.app.drawer.messageDrawer.controllers.MessageDrawerController
             * @instance
             * @description
             * Marks the message as unread
             */
            self.markMessageUnread = function markMessageUnread() {
                Tracker.events.fire('Mark As Unread', {
                    category: internal.constants.CATEGORY,
                    label: _.get(MessageListModelService.getActiveMessage(), 'message.subject', ''),
                    tags: ['button'],
                    dimension32: internal.constants.DIMENSION_32
                });
                internal.getDrawerActiveItem();
                MessageListModelService.markActiveMessageUnread()
                    .catch(function onError(error) {
                        // Log the error
                        log.warn('Could not mark the selected message as unread', error);
                        return undefined;
                    })
                    .done();
                internal.restoreActiveItem();
            };

            /**
             * @ngdoc method
             * @function createMessagePDF
             * @memberOf paychex.app.drawer.messageDrawer.controllers.MessageDrawerController
             * @instance
             * @description
             * Pass message to MessageListModelService to generate PDF
             */
            self.createMessagePDF = function createMessagePDF() {
                Tracker.events.fire('Download Message(s)', {
                    category: internal.constants.CATEGORY,
                    label: _.get(MessageListModelService.getActiveMessage(), 'message.subject', ''),
                    tags: ['button'],
                    dimension32: internal.constants.DIMENSION_32,
                    dimension35: 1
                });
                internal.getDrawerActiveItem();
                MessageListModelService.downloadActiveMessage();
                internal.restoreActiveItem();
            };

            /**
             * @description
             * Gets the total count of messages
             */
            self.totalCount = MessageListModelService.totalCount;

            /**
             * @ngdoc method
             * @function initStrings
             * @memberOf paychex.app.messages.MessageDetailController
             * @instance
             * @description
             * Translates the strings for locale.
             */

            self.initStrings = function initStrings() {
                self.locale = {};

                var translations = [
                    'png.landing.messages.drawer.highPriority'
                ];

                TranslationService.translate(translations)
                    .then(function translate(values) {
                        _.forEach(values, function iter(value, index) {
                            self.locale[translations[index]] = value;
                        });
                        return self.locale;
                    })
                    .catch()
                    .done();
            };

            /**
             * @description Checks the type of device used to access application and assign the type to #deviceType
             */
            self.isMobile = DeviceProfile.isMobile();

            self.initStrings();

            DrawerManager.registerDrawer(self, lifecycle);
        }
    ];
});

